<template>
  <div>
    <Header />
    <About />
    <Services />
    <News />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Services from "@/components/services";
import News from "@/components/news";
import About from "@/components/about";

export default {
  name: "Home",
  components: {
    Header,
    Services,
    News,
    About
  }
};
</script>

